/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoicePersonLightResponse } from './InvoicePersonLightResponse';
import {
    InvoicePersonLightResponseFromJSON,
    InvoicePersonLightResponseFromJSONTyped,
    InvoicePersonLightResponseToJSON,
    InvoicePersonLightResponseToJSONTyped,
} from './InvoicePersonLightResponse';

/**
 * 
 * @export
 * @interface InvoiceSearchItemResponse
 */
export interface InvoiceSearchItemResponse {
    /**
     * 
     * @type {number}
     * @memberof InvoiceSearchItemResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSearchItemResponse
     */
    invoiceReference?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSearchItemResponse
     */
    invoiceDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSearchItemResponse
     */
    invoiceStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSearchItemResponse
     */
    amount?: string;
    /**
     * Channel type where this invoice lives
     * @type {string}
     * @memberof InvoiceSearchItemResponse
     */
    channelType?: string;
    /**
     * Channel ID for navigation
     * @type {number}
     * @memberof InvoiceSearchItemResponse
     */
    channelId?: number;
    /**
     * 
     * @type {InvoicePersonLightResponse}
     * @memberof InvoiceSearchItemResponse
     */
    pwrCounterParty?: InvoicePersonLightResponse;
}

/**
 * Check if a given object implements the InvoiceSearchItemResponse interface.
 */
export function instanceOfInvoiceSearchItemResponse(value: object): value is InvoiceSearchItemResponse {
    return true;
}

export function InvoiceSearchItemResponseFromJSON(json: any): InvoiceSearchItemResponse {
    return InvoiceSearchItemResponseFromJSONTyped(json, false);
}

export function InvoiceSearchItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSearchItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'invoiceReference': json['invoiceReference'] == null ? undefined : json['invoiceReference'],
        'invoiceDateTime': json['invoiceDateTime'] == null ? undefined : json['invoiceDateTime'],
        'invoiceStatus': json['invoiceStatus'] == null ? undefined : json['invoiceStatus'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'channelType': json['channelType'] == null ? undefined : json['channelType'],
        'channelId': json['channelId'] == null ? undefined : json['channelId'],
        'pwrCounterParty': json['pwrCounterParty'] == null ? undefined : InvoicePersonLightResponseFromJSON(json['pwrCounterParty']),
    };
}

export function InvoiceSearchItemResponseToJSON(json: any): InvoiceSearchItemResponse {
    return InvoiceSearchItemResponseToJSONTyped(json, false);
}

export function InvoiceSearchItemResponseToJSONTyped(value?: InvoiceSearchItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'invoiceReference': value['invoiceReference'],
        'invoiceDateTime': value['invoiceDateTime'],
        'invoiceStatus': value['invoiceStatus'],
        'amount': value['amount'],
        'channelType': value['channelType'],
        'channelId': value['channelId'],
        'pwrCounterParty': InvoicePersonLightResponseToJSON(value['pwrCounterParty']),
    };
}

